import React from "react";
import { useEffect } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { OrderAction } from "store/actions";
import OrderList from "./OrderList";
import WithLoading from "components/Hoc/WithLoading";
import { PageHeaderV2 } from "components/PageHeader";
import moment from "moment";

const groupOrdersByMonthYear = (orders) => {
  const grouped = {};

  orders.forEach((order) => {
    const monthYear = moment(order.orderPlacedTime * 1000).format("MMMM YYYY");
    if (!grouped[monthYear]) {
      grouped[monthYear] = [];
    }
    grouped[monthYear].push(order);
  });

  Object.keys(grouped).forEach((key) => {
    grouped[key].sort((a, b) => b.orderPlacedTime - a.orderPlacedTime);
  });

  return Object.entries(grouped)
    .map(([monthYear, orders]) => ({ monthYear, orders }))
    .sort(
      (a, b) =>
        moment(b.monthYear, "MMMM YYYY").valueOf() -
        moment(a.monthYear, "MMMM YYYY").valueOf()
    );
};

const OrderContainer = ({ handleBack, handleOrderDetail }) => {
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state?.order);
  const { myorders } = useSelector((state) => state?.order);

  useEffect(() => {
    dispatch(OrderAction.getMyOrders());
  }, []);

  const groupedOrders = groupOrdersByMonthYear(myorders?.orders ?? []);

  if (error)
    return (
      <h2 className="text-center">
        {error?.message ?? "Error in Fetching orders"}
      </h2>
    );

  return (
    <WithLoading>
      <div className="order-page min-h-app-height max-460 relative">
        <PageHeaderV2
          containerStyleProps={{
            style: {
              zIndex: 100,
            },
          }}
          headerStyleProps={{
            className: "p-6",
          }}
          pageTitle={"Your Orders"}
          onGoBack={handleBack}
          hideAuth={true}
        />
          <br/>
          <br/>
          <br/>
          <div className="p-6 mt-3">
          {groupedOrders?.length > 0 ? (
            groupedOrders.map((order) => {
              return (
                <div key={order?.monthYear}>
                  <h2 className="text-20x text-dark-blue-900 font-bold m-0">
                    {t(order?.monthYear)}
                  </h2>
                  <OrderList
                    orderList={order?.orders}
                    handleOrderDetail={handleOrderDetail}
                  />
                </div>
              );
            })
          ) : (
            <div className="text-center mt-3 font-semibold">
              {t("You don't Have any order yet.")}
            </div>
          )}
        </div>
      </div>
    </WithLoading>
  );
};
export default OrderContainer;
